<div class="marquee-card card" *ngFor="let number of items"><div class="ghost-loader-card-animation"></div></div>
